import ExclamationIcon from 'assets/icons/exclamation-triangle.svg?component'
import Button from 'components/UI/Buttons/Button'
import { Modal } from 'components/UI/Modal'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import { useAppSelector } from 'hooks'
import useLogout from 'hooks/useLogout'
import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCancelCreditMutation } from 'redux/api/creditApi'
import { getActiveCreditApplication } from 'redux/store/slices/userSlice'
import tw, { TwStyle } from 'twin.macro'

const LoanCancelButton = ({
  buttonStyles,
  buttonTextStyles,
  disabled
}: {
  disabled?: boolean
  buttonStyles?: TwStyle
  buttonTextStyles?: TwStyle
}) => {
  const { t } = useTranslation()
  const logout = useLogout()

  const [isModalOpened, setIsModalOpened] = useState(false)

  const { id: creditID } = useAppSelector(getActiveCreditApplication)

  const [cancelCredit, { isLoading }] = useCancelCreditMutation()

  const handleCancelCredit = async () => {
    try {
      await cancelCredit(creditID as string).unwrap()
      logout()
    } catch (error) {
      console.log(error)
    }
  }

  const handleModalClose = () => {
    setIsModalOpened(false)
  }

  return (
    <Fragment>
      <Button
        type='button'
        disabled={disabled}
        variant='text'
        twStyle={buttonStyles}
        onClick={() => {
          setIsModalOpened(true)
        }}
      >
        <Typography variant='body' weight='bold' twStyle={buttonTextStyles}>
          {t('flow-cancel-apl')}
        </Typography>
      </Button>
      <Modal
        outsideClose={!isLoading}
        open={isModalOpened}
        twStyle={tw`pb-0`}
        headerStyle={tw`hidden`}
        onClose={handleModalClose}
      >
        <div tw='flex flex-col items-center'>
          <ExclamationIcon fill='#7B7B7D' width='90' height='85' />
          <Heading variant='subtitle' twStyle={tw`mt-[30px]`}>
            {t('sure-to-cancel')}{' '}
          </Heading>
          <Typography variant='body' twStyle={tw`text-grey-dark mt-2`}>
            {t('data-loosing')}
          </Typography>
          <div tw='flex justify-center w-full border-t border-stroke mt-5'>
            <Button
              type='button'
              variant='text'
              disabled={isLoading}
              twStyle={tw`text-main border-r border-stroke`}
              onClick={handleCancelCredit}
            >
              {t('yes-cancel')}
            </Button>
            <Button type='button' variant='text' disabled={isLoading} onClick={handleModalClose}>
              {t('no-cancel')}
            </Button>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default LoanCancelButton
